var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rendered_content.length > 2)?_c('v-sheet',{staticClass:"px-5 py-5 text-capitalize non-touch",attrs:{"outlined":""},domProps:{"innerHTML":_vm._s(_vm.rendered_content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }